// src/services/employeeService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const employeeService = {
  async fetchAllEmployees() {
    return await api.get("/employees", { headers: authHeader() });
  },
  fetchEmployee(id) {
    return api.get(`/employees/${id}`, { headers: authHeader() });
  },
  fetchCreateEmployee(data) {
    return api.post("/employees", data, { headers: authHeader() });
  },
  fetchUpdateEmployee(id, data) {
    return api.put(`/employees/${id}`, data, { headers: authHeader() });
  },
  fetchDeleteEmployee(id) {
    return api.delete(`/employees/${id}`, { headers: authHeader() });
  },
};

export default employeeService;
